const initialState = {
  isRefreshList: false,
  isRefreshAll: false
};

const refresh = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_DATA':
      return { ...state, ...action };
    default:
      return state;
  }
};

export default refresh;
